import { EnvironmentProviders, Provider } from '@angular/core';
import { ListingPageService } from 'src/app/shared/components/listing-page/listing-page.service';
import { QueryParamsHandlerService } from 'src/app/shared/components/listing-page/services/query-params-handler/query-params-handler.service';
import { LISTING_MODEL } from 'src/app/shared/constants/tokens';
import { RequestProcessingListingFiltersSourceService } from './request-processing-listing-filters-source.service';
import { RequestProcessingListingDataSourceService } from './request-processing-listing-data-source.service';
import { RequestProcessingListingExportConfigService } from './request-processing-listing-export-config.service';
import { RequestProcessingListingModelService } from './request-processing-listing-model.service';

export const provideRequestProcessingListing = (): (Provider | EnvironmentProviders)[] => [
  RequestProcessingListingFiltersSourceService,
  RequestProcessingListingDataSourceService,
  RequestProcessingListingExportConfigService,
  { provide: LISTING_MODEL, useClass: RequestProcessingListingModelService },
  ListingPageService,
  QueryParamsHandlerService
];
